import { Navigate, useLocation } from "react-router-dom";
import { useEffect, type ReactNode } from "react";
import { authStorage, type AuthGuard } from "services/authStorage";
import { registerWebPush } from "services/webPush";

export default function RequireAuth({
  children,
  requiredGuard = "admin",
}: {
  children: ReactNode;
  requiredGuard?: AuthGuard;
}) {
  const location = useLocation();
  const authenticated = authStorage.isAuthenticated(requiredGuard);

  // Register the web FCM token once the admin/instructor is authenticated, so
  // push works even before they open a chat. Re-registers on app start when the
  // browser permission was already granted; no-op without a VAPID key. Internally
  // guarded to run its work only once per page load.
  useEffect(() => {
    if (!authenticated) return;
    void registerWebPush().catch(() => {});
  }, [authenticated]);

  if (!authenticated) {
    return (
      <Navigate to={authStorage.loginPath(requiredGuard)} replace state={{ from: location.pathname }} />
    );
  }

  return <>{children}</>;
}
